@if (customHeader()) {
  <ng-container *ngTemplateOutlet="customHeader()" />
} @else {
  <div class="tw:w-full tw:flex tw:items-center tw:justify-between tw:pt-6 tw:px-6">
    <div class="tw:text-[1.5rem] tw:leading-8 tw:font-medium tw:text-(--p-text-color)">
      {{ label() ?? '' }}
    </div>
    @if (showClose()) {
      <div
        (click)="closeIconHandler()"
        class="tw:flex tw:items-center tw:justify-center tw:w-8 tw:h-8 tw:cursor-pointer tw:text-bluegray-900 tw:hover:bg-bluegray-100 tw:rounded-lg tw:transition-all tw:duration-300"
      >
        <pinnakl-icon
          name="thin-close"
          class="tw:flex tw:w-4 tw:h-4"
        />
      </div>
    }
  </div>
}
